import ApolloService from './apolloServices'

const apollo = new ApolloService()
export default apollo
